import Button from '@atoms/Button/Button';
import Icon from '@atoms/Icon/Icon';
import classNames from 'classnames';
import { forwardRef } from 'react';

export enum LikeButtonVariants {
  White = 'white',
  Grey = 'grey30',
  Bordered = 'bordered',
  Inline = 'inline',
}

interface Props {
  readonly onLike: () => void;
  readonly isCard?: boolean;
  readonly isLiked: boolean;
  readonly variant?: LikeButtonVariants;
  readonly saveLabel?: string;
  readonly unsaveLabel?: string;
}

const LikeButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      onLike,
      isLiked,
      isCard = true,
      variant = LikeButtonVariants.White,
      saveLabel = 'Save',
      unsaveLabel = 'Unsave',
    }: Props,
    ref
  ) => {
    if (variant === LikeButtonVariants.Inline) {
      return (
        <button
          className="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-underline hover:tw-text-grey-90 hover:tw-no-underline"
          onClick={onLike}
        >
          <Icon name={isLiked ? 'heart-activated' : 'heart'} size={14} />
          <span>{isLiked ? unsaveLabel : saveLabel}</span>
        </button>
      );
    }
    return (
      <div
        className={classNames({
          'tw-absolute tw-left-2.5 tw-top-2.5 md:tw-left-xs md:tw-top-xs':
            isCard,
          'tw-rounded-full tw-bg-white':
            variant === LikeButtonVariants.Bordered,
        })}
      >
        <Button
          iconClasses="tw-shrink-0 tw-absolute"
          variant={variant === LikeButtonVariants.White ? 'white' : 'grey30'}
          modifier={variant === LikeButtonVariants.White ? 'fill' : 'outline'}
          iconName={isLiked ? 'heart-activated' : 'heart'}
          iconSize="1rem"
          buttonClasses="tw-w-sm !tw-h-sm md:tw-w-md md:!tw-h-md tw-z-20"
          onClick={onLike}
          aria-label="Add to favorites"
          ref={ref}
        />
      </div>
    );
  }
);

export default LikeButton;
